import type {Component} from 'typings/portaro.fe.types';
import type {RecordOperation} from 'typings/portaro.be.types';

export default class RecordOperationListItemComponent implements Component<RecordOperationListItemComponentBindings> {
    public static componentName = 'kpRecordOperationListItem';

    public templateUrl = require('./record-operation-list-item.tpl.ftl');
    public bindings = {
        recordOperation: '='
    } as const;
}

interface RecordOperationListItemComponentBindings {
    recordOperation: RecordOperation;
}
